import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=0b0c7562&scoped=true"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"
import style0 from "./satisfaction.vue?vue&type=style&index=0&id=0b0c7562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c7562",
  null
  
)

export default component.exports